import { createContext, useContext, useState } from 'react';

const CasesContext = createContext();

export function CasesProvider({ children }) {
  const [cases, setCases] = useState([]);

  return (
    <CasesContext.Provider value={{ cases, setCases }}>
      {children}
    </CasesContext.Provider>
  );
}

export function useCases() {
  return useContext(CasesContext);
}